import {Router} from 'ninelines-router';
import vars from './globals';
import cardAudio from './components/card-audio';
import {productAudioInit, productAudioDestroy} from './components/product-audio';
import {animateSvg, stopSvg, lineSvgStart} from './components/morph';
import {leafsInit, leafsDestroy} from './components/leafs';
import {refreshAOS, checkProductHeroAos, cleareProductHeroAos} from './components/aos';
import scrollDepth from 'scroll-depth';
import {spentOnPage15sec, virtualHit} from './components/analytics';
import {mixerStop, mixerInit} from './components/composition';

let router = new Router();

router.addRoute({
	path: '/',
	name: 'home',
	onEnter(prevState) {
		return new Promise((resolve) => {
			vars.$html.data('page', 'home').attr('data-page', 'home');
			// TweenMax.set(vars.$body, {clearProps: 'all'});

			if (prevState.route) {
				new TimelineMax({
					onStart() {
						vars.$home.removeClass('is-hidden');
						vars.$siteContainer.removeClass('is-hidden');
						$('.aos-animate').removeClass('aos-animate');

						window.scrollTo(0, 0);
						refreshAOS();
						animateSvg();
					},
					onComplete() {
						leafsInit();
						lineSvgStart();

						cardAudio.init();
						mixerInit();

						spentOnPage15sec();
						scrollDepth.reset();
						virtualHit(location.pathname);

						resolve();
					},
				})
					.from(vars.$siteContainer, 0.5, {
						autoAlpha: 0,
						clearProps: 'all',
					});
			} else {
				new TimelineMax({
					onStart() {
						vars.$home.removeClass('is-hidden');
						vars.$siteContainer.removeClass('is-hidden');
						$('.aos-animate').removeClass('aos-animate');

						window.scrollTo(0, 0);
						animateSvg();
					},
					onComplete() {
						refreshAOS();
						leafsInit();
						lineSvgStart();

						cardAudio.init();
						mixerInit();

						resolve();
					},
				})
					.from(vars.$siteContainer, 0.5, {
						autoAlpha: 0,
						clearProps: 'all',
					});
			}
		});
	},
	onLeave() {
		return new Promise((resolve) => {
			new TimelineMax({
				onComplete() {
					vars.$siteContainer.addClass('is-hidden');
					vars.$home.addClass('is-hidden');
					$('.aos-animate').removeClass('aos-animate');

					cardAudio.destroy();
					leafsDestroy();
					stopSvg();

					mixerStop();

					resolve();
				},
			})
				.to(vars.$siteContainer, 0.5, {
					autoAlpha: 0,
					clearProps: 'all',
				});
		});
	},
});

router.addRoute({
	path: '/product',
	name: 'product',
	onEnter(prevState) {
		return new Promise((resolve) => {
			vars.$html.data('page', 'product').attr('data-page', 'product');

			if (prevState.route) {
				new TimelineMax({
					onStart() {
						vars.$product.removeClass('is-hidden').addClass('is-active');
						vars.$siteContainer.removeClass('is-hidden');
						$('.aos-animate').removeClass('aos-animate');

						checkProductHeroAos();
						window.scrollTo(0, 0);
					},
					onComplete() {
						refreshAOS();
						productAudioInit();

						spentOnPage15sec();
						scrollDepth.reset();
						virtualHit(location.pathname);

						resolve();
					},
				})
					.from(vars.$siteContainer, 0.5, {
						autoAlpha: 0,
						clearProps: 'all',
					});
			} else {
				Promise.resolve()
					.then(() => {
						new TimelineMax({
							onStart() {
								vars.$product.removeClass('is-hidden').addClass('is-active');
								vars.$siteContainer.removeClass('is-hidden');
								$('.aos-animate').removeClass('aos-animate');

								checkProductHeroAos();
								window.scrollTo(0, 0);
							},
							onComplete() {
								refreshAOS();
								productAudioInit();

								resolve();
							},
						})
							.from(vars.$siteContainer, 0.5, {
								autoAlpha: 0,
								clearProps: 'all',
							});
					});
			}
		});
	},
	onLeave() {
		return new Promise((resolve) => {
			new TimelineMax({
				onStart() {
				},
				onComplete() {
					vars.$siteContainer.addClass('is-hidden');
					vars.$product.addClass('is-hidden');
					$('.aos-animate').removeClass('aos-animate');

					productAudioDestroy();
					cleareProductHeroAos();

					resolve();
				},
			})
				.to(vars.$siteContainer, 0.5, {
					autoAlpha: 0,
					clearProps: 'all',
				});
		});
	},
});

router.on('notFound', () => {
	router.navigate('/');

	return Promise.resolve();
});

router.start();

export default router;
